import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const SendNotificationConfirmationModal = ({
  open,
  cancel,
  title,
  message,
  loading,
  handleSendNotification,
}) => {
  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions
        sx={{ marginTop: "10px", marginBottom: "8px", marginRight: "8px" }}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={cancel}
          sx={{ mr: 1 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={handleSendNotification}
          disabled={loading}
        >
          Yes, Send Now
        </Button>
        {loading && <CircularProgress size={32} />}
      </DialogActions>
    </Dialog>
  );
};

export default SendNotificationConfirmationModal;
